import {useUpmPlantContext} from '@hconnect/upm'
import {FeatureFlagKey, useCommonFeatureFlag} from '@hproduce/feature-flags'
import {BoxProps, Collapse, Stack} from '@mui/material'
import {useCallback} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {usePersistingSettingState} from '../../hooks'
import {PlannerLSSettingsKeys} from '../../types'
import {CollapsibleCard} from '../CollapsibleCard'
import {StartRecalculationButton} from '../recalculatePlan/StartRecalculationButton'

import {AnalyzeProductionPlanButton} from './AnalyzeProductionPlanButton'
import {OptimizerPlansTable} from './OptimizerPlansTable'

export const OptimizerPlansOverviewCard = (props: BoxProps & {plantCode: string}) => {
  const {plantCode, ...restProps} = props
  const {t} = useTranslation(FEATURE_NAMESPACE)

  const {plantId} = useUpmPlantContext()
  const isOptimizerPlanAnalysisEnabled = useCommonFeatureFlag(
    FeatureFlagKey.OptimizerPlanAnalysis,
    {plantId}
  )

  const [{isCardOpen}, setSettings] = usePersistingSettingState(
    PlannerLSSettingsKeys.OptimizerPageSettings,
    {isCardOpen: true}
  )

  const toggleIsMinimized = useCallback(() => {
    setSettings({isCardOpen: !isCardOpen})
  }, [setSettings, isCardOpen])

  return (
    <CollapsibleCard
      {...restProps}
      isCollapsed={!isCardOpen}
      onToggleCollapsed={toggleIsMinimized}
      title={t('optimizer.optimizedPlan')}
      headerContent={
        <Stack direction="row" spacing={1.5} sx={{justifyContent: 'flex-end'}}>
          {isOptimizerPlanAnalysisEnabled && <AnalyzeProductionPlanButton />}
          <StartRecalculationButton backgroundMode="light" />
        </Stack>
      }
    >
      <Collapse in={isCardOpen}>
        <OptimizerPlansTable plantCode={plantCode} />
      </Collapse>
    </CollapsibleCard>
  )
}
